// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-category_empty[data-v-7d993c42] {\n  height: calc(100vh - 130px);\n}\n.quotation-contract_btn[data-v-7d993c42] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
